require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-bank-lead-with-a-climate-denier-as.json") })
        }
      }, "path---en-us-update-how-can-the-world-bank-lead-with-a-climate-denier-as");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-bank-lead-with-a-climate-denier-as!./.cache/json/en-us-update-how-can-the-world-bank-lead-with-a-climate-denier-as.json
// module id = 714
// module chunks = 231608221292675